import { useMutation } from 'react-query';
import { LibType } from '@types';
import { editLibMatrix, editLibPano, editLibPVideo } from '../mediaApis';

type Params =
  | {
      libType: LibType.pano;
      id: number;
      data: Parameters<typeof editLibPano>[1];
    }
  | {
      libType: LibType.matrix;
      id: number;
      data: Parameters<typeof editLibMatrix>[1];
    }
  | {
      libType: LibType.panoVideo;
      id: number;
      data: Parameters<typeof editLibPVideo>[1];
    };

export function useLibEdit() {
  const { mutateAsync: editLib, isLoading: editLibLoading } = useMutation(
    async ({ libType, id, data }: Params) => {
      if (libType === LibType.pano) return editLibPano(id, data);
      if (libType === LibType.matrix) return editLibMatrix(id, data);
      if (libType === LibType.panoVideo) return editLibPVideo(id, data);
    }
  );
  return { editLib, editLibLoading };
}
